import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Fade, Typography, useTheme } from '@mui/material';
import * as S from '../styles';
import { DoneRounded } from '@mui/icons-material';
import { CustomIcon } from 'console/shared/components/icon/custom';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { useHeatingCircuit } from 'console/shared/components/panels/heating-circuits/heating-circuit/provider';
import { useHeatingCircuitControl } from 'console/shared/components/panels/heating-circuits/heating-circuit/provider/control';
import { formatTemp, removeNulls } from 'utils';
export const SliderTemperatureControl = memo(function SliderTemperatureControl(props) {
    const { is_off_mode, show_current_temperature } = props;
    const { temp_step } = useDeviceConfig();
    const { max_temperature, min_temperature, temperature_decimal_places, has_pza, thermometers, summer_mode, } = useHeatingCircuit();
    const { setTargetTemperature, turnOnEditingMode, turnOffEditingMode, target_temperature, success_apply_command, stopShowSuccess, target_fail, } = useHeatingCircuitControl();
    const current_temperature = thermometers?.target.temperature;
    const theme = useTheme();
    const action_label = useMemo(() => has_pza || current_temperature == null
        ? ''
        : target_temperature > current_temperature
            ? 'Нагрев t° до:'
            : 'Снижение t° до:', [target_temperature, current_temperature, has_pza]);
    const onChangeTargetTemperature = useCallback((_, value) => {
        if (!Array.isArray(value)) {
            setTargetTemperature(value);
        }
    }, []);
    const marks = useMemo(() => removeNulls([
        { label: `${min_temperature}°`, value: min_temperature },
        { label: `${max_temperature}°`, value: max_temperature },
        show_current_temperature && current_temperature
            ? {
                label: formatTemp(current_temperature),
                value: current_temperature < min_temperature
                    ? min_temperature
                    : Number(current_temperature.toFixed(temperature_decimal_places)),
            }
            : null,
    ]), [
        min_temperature,
        max_temperature,
        current_temperature,
        show_current_temperature,
        temperature_decimal_places,
    ]);
    const [show_fail, setShowFail] = useState(false);
    useEffect(() => {
        if (target_fail) {
            setShowFail(true);
            setTimeout(() => setShowFail(false), 4000);
        }
    }, [target_fail]);
    return (_jsxs(Box, { width: "90%", margin: "0 auto", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", rowGap: 1, children: [_jsx(Fade, { in: success_apply_command, onEntered: stopShowSuccess, timeout: 1e3, children: _jsx(CustomIcon, { color: summer_mode ? 'disabled' : 'success', fontSize: "2.5rem", Icon: DoneRounded }) }), _jsxs(Box, { display: "flex", alignItems: "center", flexDirection: "column", rowGap: 1.5, width: "100%", children: [_jsx(Box, { display: "flex", flexDirection: "column", height: 20, children: _jsx(Fade, { in: !is_off_mode && !summer_mode, children: _jsx(Typography, { fontSize: "1rem", color: "textSecondary", children: action_label }) }) }), !is_off_mode ? (_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", children: [summer_mode && (_jsx(Typography, { fontSize: "1.5rem", color: theme.palette.action.disabled, children: "\u041B\u0435\u0442\u043D\u0438\u0439 \u0440\u0435\u0436\u0438\u043C" })), _jsxs(Typography, { fontSize: "2.5rem", color: show_fail
                                    ? theme.palette.error.main
                                    : summer_mode
                                        ? theme.palette.action.disabled
                                        : theme.palette.heat.main, children: ['\u00A0', formatTemp(target_temperature)] })] })) : (_jsx(Typography, { fontSize: "2.5rem", color: theme.palette.action.disabled, children: "\u041E\u0442\u043A\u043B\u044E\u0447\u0451\u043D" })), _jsx(Box, { onPointerDown: turnOnEditingMode, onPointerUp: turnOffEditingMode, width: "100%", children: _jsx(S.SliderTemperatureControl, { is_off_mode: is_off_mode, summer_mode: summer_mode, value: target_temperature ?? min_temperature, step: temp_step, onPointerUp: turnOffEditingMode, onChange: onChangeTargetTemperature, min: min_temperature, max: max_temperature, marks: marks, "data-tooltip": "fancy-change-temp", show_fail: show_fail ? show_fail.toString() : undefined }) })] })] }));
});
